import { fetchGet } from '~utilities/fetch';

export async function applicationEmailsListRequest(applicationUuid: string, page: number, perPage: number): Promise<Response> {
    return fetchGet(`/applications/${applicationUuid}/emails`, {
        page,
        perPage,
    });
}

export async function applicationEmailTextRequest(applicationEmailUuid: string): Promise<Response> {
    return fetchGet(`/application-emails/${applicationEmailUuid}/text`);
}
